import { Checkbox, Input } from '@seiue/ui'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import React, { useContext } from 'react'
import styled from 'styled-components'

import { FieldTypeEnum } from 'packages/sdks-next/growp'
import { EntryComponentsWrapper } from 'packages/theme'

import { SelectSpeacialSetting } from './SelectSpeacialSetting'
import { QuestionnaireContext } from './context'
import mouseCursor from './images/mouseCursor.svg'
import {
  BaseQuestionnaire,
  changeQuestionnaireData,
  typeToLabel,
} from './utils'

/**
 * 问卷 - 题目设置区域
 *
 * @returns React.ReactNode
 */
export const TopicSetting: React.FC = () => {
  const { activeItemIndex, questionnaires, setQuestionnaires } =
    useContext(QuestionnaireContext)
  const questionnaireList = questionnaires || []
  const currentQuestionnaire =
    activeItemIndex !== undefined
      ? questionnaireList[activeItemIndex]
      : BaseQuestionnaire
  const { type, require } = currentQuestionnaire || {}

  const onCheckedRequried = (e: CheckboxChangeEvent) => {
    const newQuestionnaire = changeQuestionnaireData(
      questionnaires,
      activeItemIndex || 0,
      {
        ...currentQuestionnaire,
        require: e.target.checked,
      }
    )
    setQuestionnaires([...newQuestionnaire])
  }

  return (
    <Wrapper>
      <Hearder>题目设置</Hearder>
      {activeItemIndex !== undefined &&
      questionnaires.length > 0 &&
      ![FieldTypeEnum.Describe, FieldTypeEnum.PageBreak].includes(type) ? (
        <>
          <EntryComponentsWrapper>
            <BaseSetting>
              <Title>题目类型</Title>
              <Input
                disabled={true}
                value={type ? typeToLabel.get(type) : undefined}
              />
              <Checkbox
                checked={require}
                onChange={onCheckedRequried}
              >
                必填
              </Checkbox>
            </BaseSetting>
            <SelectSpeacialSetting />
          </EntryComponentsWrapper>
        </>
      ) : (
        <EmptyWrapper>
          <ImgContent>
            <img src={mouseCursor} />
            <div>选中题型后即可进行编辑</div>
          </ImgContent>
        </EmptyWrapper>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 320px;
  min-width: 320px;
  height: 100%;
  box-shadow: 0px 0px 1px 0px rgba(21, 29, 41, 0.2),
    0px 3px 8px -1px rgba(21, 29, 41, 0.04);
  overflow: auto;
`

const Hearder = styled.div`
  width: 100%;
  height: 54px;
  padding: 16px 20px;
  box-shadow: inset 0px -1px 0px 0px #e5e6e8;
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.text._1};
`

const BaseSetting = styled.div`
  width: 100%;
  height: 132px;
  padding: 16px 20px;
  box-shadow: inset 0px -1px 0px 0px #e5e6e8;
  .ant-input {
    width: 100%;
    height: 32px;
    margin-bottom: 16px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    background-color: ${(props) => props.theme.background._3};
  }
  .ant-input-disabled {
    color: ${(props) => props.theme.text._1};
  }
  .ant-checkbox-wrapper {
    & > span {
      font-size: 14px;
      color: ${(props) => props.theme.text._2};
    }
  }
`

const Title = styled.div`
  width: 100%;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.text._2};
`

const EmptyWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ImgContent = styled.div`
  margin-top: 240px;
  & > img {
    width: 64px;
    height: 64px;
    margin-left: 45px;
    margin-bottom: 12px;
  }
  & > div {
    font-size: 14px;
    color: ${(props) => props.theme.text._2};
  }
`
